
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/unsat-terms",
      function () {
        return require("private-next-pages/unsat-terms.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/unsat-terms"])
      });
    }
  